import React, {useCallback, useState} from "react";

import {
	TermsButton,
	TermsCheckBoxContainer,
	TermsText,
	TermsTitle,
	type ITermsModalProps
} from "components/CheckTerms/common";
import {Trans, useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {isBettingCountySelector} from "modules/selectors";
import {Exist} from "components/Exist";

export const TermsONBetting: React.FC<ITermsModalProps> = ({
	trackActionRules,
	onPlay,
	handlerChange,
	isChecked,
}) => {
	const [isFirstStep, setIsFirstStep] = useState<boolean>(true);
	const {t} = useTranslation();
	const isBettingCountry = useSelector(isBettingCountySelector);
	const className = isFirstStep ? "invisible" : "";

	const handleButtonClick = useCallback(() => {
		if (isFirstStep) {
			setIsFirstStep(false);
		} else {
			onPlay?.();
		}
	}, [isFirstStep, onPlay]);

	if (!isBettingCountry) {
		return null;
	}

	return (
		<React.Fragment>
			<TermsTitle>{t("terms_modal.title_usa")}</TermsTitle>
			<TermsText>
				<Exist when={isFirstStep}>
					<Trans i18nKey="terms_modal.content.description_ca">
						By clicking "Play Now", I acknowledge that I have read, understand, and
						agree to be bound by the{" "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/apps/beat-the-streak/official-rules-ca"
						>
							Official Rules
						</a>
						{", "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/official-information/terms-of-use"
						>
							Terms of Use
						</a>
						, and{" "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/official-information/privacy-policy"
						>
							MLB Privacy Policies
						</a>
					</Trans>
				</Exist>
				<TermsCheckBoxContainer className={className}>
					<input type="checkbox" onChange={handlerChange} />
					<Trans i18nKey="terms_modal.acknowledge_olg">
						I acknowledge that I have read, understand, and agree to be bound by the{" "}
						<a
							target="_blank"
							rel="noreferrer"
							href="https://www.olg.ca/en/privacy-and-cookie-policy.html"
						>
							OLG Privacy Policy
						</a>{" "}
						and I consent to my registration and game information being shared with OLG,
						which may send me emails and/or messages regarding its products and
						services.
					</Trans>
				</TermsCheckBoxContainer>
			</TermsText>
			<TermsButton type={"button"} onClick={handleButtonClick} disabled={isChecked}>
				{isFirstStep ? t("terms_modal.on.button_one") : t("terms_modal.on.button_two")}
			</TermsButton>
			<div className="abbrev-rules">
				<Trans i18nKey="terms_modal.no_purchase">
					NO PURCHASE NECESSARY. Open to legal residents of the U.S. and Canada (excluding
					Quebec), 21+. Enter by the earlier of the conclusion of the final game of the
					2023 MLB regular season or confirmation that Grand Prize has been won. Void
					where prohibited. Restrictions apply; click for{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/apps/beat-the-streak/official-rules-ca"
					>
						Official Rules
					</a>
					. Sponsor: MLB Advanced Media, L.P.
				</Trans>
			</div>
		</React.Fragment>
	);
};
